(function() {
	'use strict';

	angular.module('smb-app')
		.factory('smbContentTypeGroupTagTypeConfigService', [
			'$http',
			'$q',
			'pxUriPathService',
			ContentTypeGroupTagTypeConfigService
		]);

	/**
	 * @typedef {Object} TagTypeConstraints
	 * @property {String} DefaultValue A default value for a tag type
	 * @property {String[]} DataSetValues An array of values for the tag type. If this exists
	 * the tag type value must be one of the values in this array.
	 */

	/**
	 * @typedef {Object} TagTypeLinks
	 * @property {String} TagValuesUri Uri to get all tag values associated to a tag type.
	 * @property {String} DataSetValuesUri Uri to get the data set values for a tag type.
	 */
	
	/**
	 * @typedef {Object} TagType
	 * @property {Number} TagTypeId The unique id of the tag type.
	 * @property {String} TagTypeName The name of the tag type.
	 * @property {String} FlavorName The flavor name?  TODO: Not sure what this is
	 * @property {Number} DataType Numeric representation of the data type.
	 * @property {String} DataTypeName String representation of the data type.
	 * @property {TagTypeConstraints} Constraints The contraints for the tag type.
	 * @property {TagTypeLinks} Links The related links for a tag type.
	 */

	/**
	 * @typedef {Object} CreateTagType
	 * @description
	 * Defines the minimum required properties on an object used to create a new tag type.
	 * @property {String} TagTypeName The name for the new tag type.
	 * @property {Number} DataType Numeric representation of the tag types data type.
	 * @property {TagTypeConstraints} Contraints Can optionally specify the constraints when creating the tag type.
	 */

	/**
	* @ngdoc service
	* @name smb-app.smbContentTypeGroupTagTypeConfigService
	*
	* @description
	* Exposes methods for configuring tag types for content type groups
	*/
	function ContentTypeGroupTagTypeConfigService($http, $q, pxUriPathService) {

		return {
			/**
			 * @ngdoc method
			 * @name smbContentTypeGroupTagTypeConfigService#getTagTypes
			 * @methodOf smb-app.smbContentTypeGroupTagTypeConfigService
			 * @kind function
			 * 
			 * @description
			 * Gets the collection of all tag types associated with a content type group.
			 * 
			 * @param {String} groupId Id of the content type group
			 * 
			 * @returns {Deferred<TagType[]>} A promise that resolves to a collection of
			 * all TagType objects associated with the content type group.
			 */
			getTagTypes: getTagTypes,

			/**
			 * @ngdoc method
			 * @name smbContentTypeGroupTagTypeConfigService#createTagType
			 * @methodOf smb-app.smbContentTypeGroupTagTypeConfigService
			 * @kind function
			 * 
			 * @description
			 * Creates a new tag type and associates it with a content type group.
			 * 
			 * @param {String} groupId Id of the content type group to associate the
			 * new tag type with.
			 * @param {CreateTagType} tagType The tag type object to create
			 * 
			 * @returns {Deferred<TagType>} Returns a promise that resolves to the newly
			 * created tag type.
			 */
			createTagType: createTagType,

			/**
			 * @ngdoc method
			 * @name smbContentTypeGroupTagTypeConfigService#editTagType
			 * @methodOf smb-app.smbContentTypeGroupTagTYpeConfigService
			 * @kind method
			 * 
			 * @description
			 * Saves changes to an existing tag type.
			 * 
			 * @param {ObjectId} groupId Id the the document type group that owns the tag type.
			 * @param {TagType} tagType The tag type object to update
			 * 
			 * @returns {Promise<TagType>} A promise that resolves to the tag type that was updated.
			 */
			editTagType: editTagType
		};

		function getTagTypes(groupId) {
			var uri = pxUriPathService.resolvePath('/libraries/' + groupId + '/tagtypes');
			return $http.get(uri)
				.then(function(res) {
					return res.data;
				});
		}

		function createTagType(groupId, tagType) {
			if (!tagType) {
				return $q.reject(new Error('Invalid request: Must specify the tag type to create'));
			}

			var uri = pxUriPathService.resolvePath('/libraries/' + groupId + '/tagtypes');
			return $http.post(uri, tagType)
				.then(function(res) {
					return res.data;
				});
		}

		function editTagType(groupId, tagType) {
			var url = '/libraries/' + groupId + '/tagtypes/' + tagType.TagTypeId;
			return $http.patch(pxUriPathService.resolvePath(url), tagType)
				.then(function(res) { return res.data; });
		}

	}
}());


//////////////////
// WEBPACK FOOTER
// ./app/services/contentConfigServices/contentTypeGroupTagTypeConfigService.js
// module id = 137
// module chunks = 1